import React, {useState} from 'react';
import {css} from "@emotion/css";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoPasswordOutlined,
    RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";

const ChangePasswordCardComponent = (
    {
        service,
        adminId = -1
    }) => {

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [lastPassword, setLastPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [repeatNewPassword, setRepeatNewPassword] = useState("");

    function doChangePassword() {
        if (checkFields()) {
            loading.show()
            if (adminId === -1) {
                updateAdminPassword()
            } else {
                updateManagerPassword()
            }
        }
    }

    function updateManagerPassword() {
        service.changeManagerPasswordById(adminId, newPassword)
            .then(_ => {
                showSuccessMessage("رمز عبور با موفقیت بروزرسانی شد.")
                clearFields()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function updateAdminPassword() {
        service.changePassword(lastPassword, newPassword)
            .then(response => {
                showSuccessMessage("رمز عبور با موفقیت بروزرسانی شد.")
                clearFields()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function clearFields() {
        setLastPassword("")
        setNewPassword("")
        setRepeatNewPassword("")
    }

    function checkFields() {
        let message = ""
        let state = true

        if (lastPassword.length < 8 && adminId === -1) {
            state = false
            message = "لطفا رمز عبور قبلی خود را به درستی وارد نمایید!"
        } else if (newPassword.length < 8) {
            state = false
            message = "رمز عبور جدید حداقل باید 8 کاراکتر باشد!"
        } else if (newPassword !== repeatNewPassword) {
            state = false
            message = "تکرار رمز عبور با رمز عبور جدید مطابقت ندارد!"
        }

        if (message.length > 0)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"ویرایش رمز عبور"}
                    hasActionButton
                    actionButtonOnclick={doChangePassword}
                >
                    <RaikoGridOneColumn>
                        <RaikoAlert
                            title={"لطفا نکات زیر را مورد توجه قرار دهید:"}
                            type={raikoAlertTypes.warning}
                            description={
                                [
                                    "رمز عبور حداقل باید کاراکتر باشد.",
                                    "برای داشتن رمزی قوی تر از حروف بزرگ و کوچک، کاراکتر ها و اعداد با یکدیگر استفاده نمایید."
                                ]}
                        />

                        {adminId === -1 &&
                            <RaikoGridThreeColumn className={css`margin-top: 1rem;`}>
                                <RaikoPasswordOutlined
                                    value={lastPassword}
                                    setValue={setLastPassword}
                                    labelText={"رمز عبور قبلی"}
                                />
                                <RaikoPasswordOutlined
                                    value={newPassword}
                                    setValue={setNewPassword}
                                    labelText={"رمز عبور جدید"}
                                />
                                <RaikoPasswordOutlined
                                    value={repeatNewPassword}
                                    setValue={setRepeatNewPassword}
                                    labelText={"تکرار رمز عبور جدید"}
                                />


                            </RaikoGridThreeColumn>
                        }

                        {adminId !== -1 &&
                            <RaikoGridTwoColumn className={css`margin-top: 1rem;`}>
                                <RaikoPasswordOutlined
                                    value={newPassword}
                                    setValue={setNewPassword}
                                    labelText={"رمز عبور جدید"}
                                />

                                <RaikoPasswordOutlined
                                    value={repeatNewPassword}
                                    setValue={setRepeatNewPassword}
                                    labelText={"تکرار رمز عبور جدید"}
                                />
                            </RaikoGridTwoColumn>
                        }
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>)
}

export default ChangePasswordCardComponent